import { Modal, Button } from "antd";
import Colors from "../../../Helper/Colors";
import lang from "../lang/lang.json";

const AcceptModal = ({ open, setOpen, confirmAction, loading }) => {
  return (
    <Modal
      ariaHideApp={false}
      open={open}
      onCancel={() => setOpen(false)}
      className="techapp-action-digital-factor-modal"
      style={{ borderRadius: "6px", textAlign: "center" }}
      title={lang.ACCEPT_ORDER}
      footer={<></>}
    >
      <div>
        <div style={{ fontWeight: 900, direction: "rtl" }}>
          {lang.ACCEPT_ORDER_DESCRIPTION}
        </div>
        <div style={{ marginTop: "10px" }}>
          <Button
            onClick={() => setOpen(false)}
            className="tech-app-reset-data-btns btn-text-black"
            style={{
              backgroundColor: "rgba(199, 199, 199, 0.322)",
              color: "black",
            }}
          >
            {lang.CANCEL}
          </Button>
          <Button
            onClick={confirmAction}
            className="tech-app-reset-data-btns btn-text-white accept_order_btn"
            style={{ backgroundColor: Colors.royalBlue, color: "white" }}
            loading={loading}
          >
            {lang.ACCEPT}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
export default AcceptModal;
